define([
    '../Util/defaultValue',
    '../Util/defined'
], function (
    defaultValue,
    defined
) {
    'use strict'

    /**
     * WMS图层信息类，存储WMS图层的元数据信息
     * @alias WMSInformation
     * @constructor
     */
    class WMSInformation {
        /**
         * @description 图层名称
         * @type {String}
         */
        layerName = '';

        /**
         * @description 样式名称
         * @type {String}
         */
        style = '';

        /**
         * @description 坐标参考系
         * @type {String}
         */
        srs = '';

        /**
         * @description 最小X坐标
         * @type {Number}
         */
        minX = 0;

        /**
         * @description 最小Y坐标
         * @type {Number}
         */
        minY = 0;

        /**
         * @description 最大X坐标
         * @type {Number}
         */
        maxX = 0;

        /**
         * @description 最大Y坐标
         * @type {Number}
         */
        maxY = 0;

        /**
         * @description 图片格式
         * @type {String}
         */
        format = 'image/png';

        /**
         * @description 协议版本
         * @type {String}
         */
        version = '1.3.0';

        /**
         * @description 可用的坐标参考系列表
         * @type {Array<String>}
         */
        availableCRS = [];

        /**
         * @description 可用的样式列表
         * @type {Array<Object>}
         */
        availableStyles = [];

        /**
         * @description 图层标题
         * @type {String}
         */
        title = '';

        /**
         * @description 图层描述
         * @type {String}
         */
        abstract = '';

        /**
         * @description 关键词列表
         * @type {Array<String>}
         */
        keywords = [];
		
		/**
         * @description 在CooWasm中类名。
         * @private
         * @readonly
         */
        className = "WMSInformation"

        /**
         * 创建WMS图层信息对象
         * @param {Object} [props] 配置选项
         */
        constructor(props) {
            if (defined(props)) {
                this.layerName = defaultValue(props.layerName, '');
                this.style = defaultValue(props.style, '');
                this.srs = defaultValue(props.srs, '');
                this.minX = defaultValue(props.minX, 0);
                this.minY = defaultValue(props.minY, 0);
                this.maxX = defaultValue(props.maxX, 0);
                this.maxY = defaultValue(props.maxY, 0);
                this.format = defaultValue(props.format, 'image/png');
                this.version = defaultValue(props.version, '1.3.0');
                this.availableCRS = defaultValue(props.availableCRS, []);
                this.availableStyles = defaultValue(props.availableStyles, []);
                this.title = defaultValue(props.title, '');
                this.abstract = defaultValue(props.abstract, '');
                this.keywords = defaultValue(props.keywords, []);
            }
        }

        /**
         * 获取GetMap请求URL
         * @param {Object} [props] 配置选项
         * @param {String} props.url 服务地址
         * @param {Number} [props.width=256] 图片宽度
         * @param {Number} [props.height=256] 图片高度
         * @param {String} [props.format] 覆盖默认图片格式
         * @param {String} [props.style] 覆盖默认样式
         * @param {String} [props.srs] 覆盖默认坐标参考系
         * @returns {String} GetMap请求URL
         */
        getMapUrl(props) {
            if (!defined(props) || !defined(props.url)) {
                throw new Error('url参数是必需的');
            }

            const width = defaultValue(props.width, 256);
            const height = defaultValue(props.height, 256);
            const format = defaultValue(props.format, this.format);
            const style = defaultValue(props.style, this.style);
            const srs = defaultValue(props.srs, this.srs);

            let url = props.url;
            if (url.indexOf('?') === -1) {
                url += '?';
            } else if (!url.endsWith('?') && !url.endsWith('&')) {
                url += '&';
            }

            // WMS 1.3.0使用CRS参数，而1.1.1使用SRS参数
            const crsParam = this.version === '1.3.0' ? 'CRS' : 'SRS';
            // BBOX顺序在1.3.0和EPSG:4326时为minY,minX,maxY,maxX，其他情况为minX,minY,maxX,maxY
            let bbox;
            if (this.version === '1.3.0' && (srs === 'EPSG:4326' || srs === 'CRS:84')) {
                bbox = `${this.minY},${this.minX},${this.maxY},${this.maxX}`;
            } else {
                bbox = `${this.minX},${this.minY},${this.maxX},${this.maxY}`;
            }

            return `${url}SERVICE=WMS&REQUEST=GetMap&VERSION=${this.version}&LAYERS=${this.layerName}&STYLES=${style}&${crsParam}=${srs}&BBOX=${bbox}&WIDTH=${width}&HEIGHT=${height}&FORMAT=${format}`;
        }
    }

    return WMSInformation;
});